import React from 'react';
import { Presentation, Download, Copy, Sparkles, CheckCircle2, Globe, FileSpreadsheet, FileText, BookOpen } from 'lucide-react';
import { OfficeHostType } from '../services/officeService';

interface HeaderProps {
  host: OfficeHostType;
  onInsert: () => void;
  onCopyImage: () => void;
  onDownloadSvg: () => void;
  isInserting: boolean;
  statusMessage: string | null;
}

export const Header: React.FC<HeaderProps> = ({
  host,
  onInsert,
  onCopyImage,
  onDownloadSvg,
  isInserting,
  statusMessage,
}) => {
  const getHostIcon = () => {
    switch (host) {
      case 'Excel': return <FileSpreadsheet size={20} color="#FFFFFF" />;
      case 'Word': return <FileText size={20} color="#FFFFFF" />;
      case 'OneNote': return <BookOpen size={20} color="#FFFFFF" />;
      default: return <Presentation size={20} color="#FFFFFF" />;
    }
  };

  const getHostTitle = () => {
    return 'Gantt for M365';
  };

  const getInsertButtonText = () => {
    if (isInserting) return 'Inserting...';
    switch (host) {
      case 'Excel': return 'Insert to Sheet';
      case 'Word': return 'Insert to Doc';
      case 'OneNote': return 'Insert to Page';
      case 'PowerPoint': return 'Insert to Slide';
      default: return 'Copy to Slide';
    }
  };

  return (
    <header className="header-container">
      <div className="header-top">
        <div className="brand">
          <div className="brand-icon">
            {getHostIcon()}
          </div>
          <div>
            <h1 className="brand-title">{getHostTitle()}</h1>
            <div className="brand-host-badge">
              {host !== 'Browser' ? (
                <span className="badge badge-office">
                  <CheckCircle2 size={12} /> {host} Connected
                </span>
              ) : (
                <span className="badge badge-preview">
                  <Globe size={12} /> Browser Preview Mode
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="header-actions">
          <button
            onClick={onCopyImage}
            className="btn btn-secondary btn-sm"
            title="Copy visual chart image to clipboard (Ready to paste with Cmd+V / Ctrl+V)"
          >
            <Copy size={15} />
            <span>Copy Image</span>
          </button>
          <button
            onClick={onDownloadSvg}
            className="btn btn-secondary btn-sm"
            title="Download SVG vector file"
          >
            <Download size={15} />
            <span>Export SVG</span>
          </button>
          <button
            onClick={onInsert}
            disabled={isInserting}
            className="btn btn-primary"
            title={host !== 'Browser' ? `Insert directly into ${host}` : 'Copy image to clipboard'}
          >
            <Sparkles size={16} />
            <span>{getInsertButtonText()}</span>
          </button>
        </div>
      </div>

      {statusMessage && (
        <div className="status-banner">
          <span>{statusMessage}</span>
        </div>
      )}
    </header>
  );
};
